import React from "react";
import { Routes, Route, NavLink, Navigate, Outlet } from "react-router-dom";

import Actions from "./actions/index";
import Dashboard from "./Dashboard";
import Events from "./Events";
import Campaigns from "./Campaigns";
import Reports from "./reports";
import Updates from "./updates/index.js";
import Email from "./email";
import Docs from "./docs";
import EmailTemplates from "./email_template";
import PhaseTransitions from "./phase_transition";
import Status from "./status";

const Nav = () => {
  const smallStyle = { marginLeft: 12, fontSize: 13, color: '#666' };

  // Primary workflow (left) — keep these limited and in sequence
  const primary = [
    { to: 'dashboard', label: 'Dashboard' },
    { to: 'campaigns', label: 'Campaigns' },
    { to: 'reports', label: 'Reports' },
    { to: 'events', label: 'Events' },
    { to: 'actions', label: 'Actions' },
    { to: 'actions/updates', label: 'Updates' },
  ];

  // Secondary / utility views (right)
  const secondary = [
    { to: 'emails', label: 'Emails' },
    { to: 'email-templates', label: 'Email Templates' },
    { to: 'phase-transitions', label: 'Phase Transitions' },
    { to: 'status', label: 'Status' },
    { to: 'docs', label: 'Docs' },
  ];

  return (
    <nav style={{ padding: 12, display: 'flex', alignItems: 'center', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {primary.map((p, i) => (
          <div key={p.to} style={{ display: 'flex', alignItems: 'center' }}>
            <NavLink to={p.to} style={{ textDecoration: 'none' }}>
              {({ isActive }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ color: isActive ? '#0b5fff' : '#888', marginRight: 6 }}>{i + 1}.</span>
                  <span style={{ ...(isActive ? { color: '#0b5fff', fontWeight: 600 } : { color: '#333' }), marginRight: 16 }}>{p.label}</span>
                </div>
              )}
            </NavLink>
          </div>
        ))}
      </div>

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
        {secondary.map((s) => (
          <NavLink key={s.to} to={s.to} style={({ isActive }) => ({ ...smallStyle, textDecoration: 'underline', color: isActive ? '#0b5fff' : '#666' })}>
            {s.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default function Action() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <h1 style={{ margin: 12 }}>Admin — Action Planning</h1>
      <Nav />
      <div style={{ padding: 12 }}>
        <Routes>
          <Route path="" element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard/*" element={<Dashboard />} />
          <Route path="actions/*" element={<Actions />} />
          <Route path="actions/updates/*" element={<Updates />} />
          <Route path="events/*" element={<Events />} />
          <Route path="reports/*" element={<Reports />} />
          <Route path="campaigns/*" element={<Campaigns />} />
          <Route path="docs/*" element={<Docs />} />
          <Route path="emails/*" element={<Email />} />
          
          <Route path="email-templates/*" element={<EmailTemplates />} />
          <Route path="phase-transitions/*" element={<PhaseTransitions />} />
          <Route path="status/*" element={<Status />} />
          <Route path="*" element={<div>Not found</div>} />
        </Routes>
        <Outlet />
      </div>
    </div>
  );
}

